import { RightOutlined } from '@ant-design/icons';
import { Breadcrumb, Tag } from 'antd';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './AssetDetailTitle.module.scss';

type AssetDetailTitleProps = {
  assetTitle?: ReactNode;
  hotelId?: number;
  hotelName?: string;
  className?: string;
  isNewDataModel?: boolean;
};

export const AssetDetailTitle = ({
  assetTitle,
  hotelId,
  hotelName,
  className,
  isNewDataModel,
}: AssetDetailTitleProps) => {
  const hasHotel = Boolean(hotelId);

  return (
    <span
      className={[styles.assetDetailTitle, className].filter(Boolean).join(' ')}
    >
      <Breadcrumb separator={<RightOutlined />}>
        {hasHotel && (
          <Breadcrumb.Item>
            <Link
              to={`/hotels/${hotelId}/edit`}
              className={styles.assetDetailTitleLink}
            >
              {hotelName}
            </Link>
          </Breadcrumb.Item>
        )}
        <Breadcrumb.Item>
          <span className={styles.assetDetailTitleAsset}>{assetTitle}</span>
        </Breadcrumb.Item>
      </Breadcrumb>
      {isNewDataModel === undefined ? null : isNewDataModel ? (
        <Tag color="#87d068">New data model</Tag>
      ) : (
        <Tag color="#f50">Old data model</Tag>
      )}
    </span>
  );
};
